import { Client } from '../../types/menu';
import React from 'react';
import classnames from 'classnames';
import { Checkbox, Radio } from 'antd';
import useHelpers from '../../hooks/utility/useHelpers';
import { WithClassname } from '../../types';

export type Props = WithClassname & {
  data: Client.Modifier;
  isSelected: boolean;
  isSingleSelect: boolean;
  toggle: (modifier: Client.Modifier) => void;
};

export default function Modifier({ data, isSelected, isSingleSelect, toggle, className }: Props) {
  const { formatCurrency } = useHelpers();

  function toggleModifier(): void {
    if (!data.is_available) {
      return;
    }

    toggle(data);
  }

  return (
    <button className={classnames('flex w-full', className)} onClick={toggleModifier}>
      <div className="mr-xs my-auto">
        {isSingleSelect ? <Radio checked={isSelected} /> : <Checkbox checked={isSelected} />}
      </div>
      <div className="flex-1 my-auto">
        <p
          className={classnames('mr-xs text-left', {
            'opacity-25': !data.is_available,
          })}
        >
          {data.name}
        </p>
      </div>
      {data.is_available && (
        <p className="text-gray-700 text-right text-sm">+ {formatCurrency(data.price)}</p>
      )}
      {!data.is_available && <p className="ml-xs text-brand-primary my-auto">Sold out!</p>}
    </button>
  );
}
